<template>
    <div class="a-dropdown dropdown">
        <Select
            v-model="localValue"
            :disabled="disabled"
            :placement="placement"
            :clearable="clearable"
            :prefix="prefixCssClass"
            :filterable="filterable"
            :placeholder="placeholder"
            @on-change="handleChange"
            @on-clear="handleClear"
            @on-open-change="handleOpenChange"
        >
            <Option
                v-for="(item, index) in items"
                :key="index + '-' + randomKeyPrefix + '-' + item[keyField]"
                :at-a-dropdown-options="item[keyField]"
                :value="item[keyField]"
                :label="item[nameField]"
                :class="{'hide-option': item[keyField] === value }"
                :disabled="item[keyField] === value"
            >
                <slot name="select-option" :option="item">
                    {{ item[nameField] }}
                </slot>
            </Option>
        </Select>
    </div>
</template>
<script>

export default {
    name: 'ADropdown',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        },
        nameField: {
            type: String,
            default: 'name'
        },
        keyField: {
            type: String,
            default: 'id'
        },
        isPrefix: {
            type: Boolean,
            default: false
        },
        placement: {
            type: String,
            default: 'bottom-start'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: [String, null],
            default: 'Select'
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        },
        randomKeyPrefix(){
            return Math.floor(Math.random() * 1000);
        },
        prefixCssClass() {
            return this.isPrefix
                ? `dropdown__header-icon--${this.localValue}`
                : null;
        }
    },
    methods: {
        handleOpenChange(e) {
            this.$emit('onOpenChange', e);
        },
        handleChange(e) {
            this.$emit('onChange', e);
        },
        handleClear() {
            this.$emit('onClear');
        }
    }
};
</script>

<style lang="scss" src="./a-dropdown.scss" />